export const environment = {
  production: true,
  GENESYS_CLOUD_CLIENT_ID: '58c18fee-ca40-47e0-b82f-98072bb97fd4',
  REDIRECT_URI: 'https://sat.outsourcia.com',
  API_URI: 'https://api-sat.outsourcia.com',
  APIBI_URI: 'https://api-sat-bi.outsourcia.com'
  // REDIRECT_URI: 'http://172.29.200.58:8000',
  // API_URI: 'http://172.29.200.58:7000',
  // APIBI_URI: 'http://172.29.200.58:6000'
};
